<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item">
        <md-card>
          <md-card-header :data-background-color="dataBackgroundColor">
            <h4 class="title">Panel de Administración</h4>
            <p class="category">Modificar importes agrupados por categoría</p>
          </md-card-header>

          <md-card-content>
            <div v-for="categoria in categorias" :key="categoria.categoria_id" class="mb-6">
              <h5><strong>{{ categoria.categoria_nombre }}</strong></h5>
              <table class="table table-bordered" style="width: 100%">
                <thead>
                  <tr>
                    <th>Servicio</th>
                    <th>Importe por contrato (Bs)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="servicio in categoria.servicios" :key="servicio.servicio_id">
                    <td>{{ servicio.servicio_nombre }}</td>
                    <td>
                      <input
                        type="number"
                        v-model.number="servicio.valor_unitario"
                        class="form-control"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <md-button class="md-success" @click="guardarCambios">
              Guardar Cambios
            </md-button>

            <div v-if="guardado" class="text-success mt-3">
              Cambios guardados correctamente.
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataBackgroundColor: {
      type: String,
      default: 'green'
    }
  },
  data() {
    return {
      categorias: [],
      guardado: false
    };
  },
  methods: {
    async cargarServicios() {
      try {
        const response = await fetch('https://alexpruebas.tamep.bo/kqlurhnh_conciliacion/manage/obtener_servicios.php');
        const data = await response.json();
        this.categorias = data;
      } catch (error) {
        console.error('Error al cargar servicios:', error);// eslint-disable-line no-console
      }
    },
    async guardarCambios() {
      this.guardado = false;
      const cambios = [];

      this.categorias.forEach(categoria => {
        categoria.servicios.forEach(servicio => {
          cambios.push({
            servicio_id: servicio.servicio_id,
            valor_unitario: servicio.valor_unitario
          });
        });
      });

      try {
        const response = await fetch('https://alexpruebas.tamep.bo/kqlurhnh_conciliacion/manage/guardar_servicios.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(cambios)
        });

        const result = await response.json();
        if (result.success) {
          this.guardado = true;
        }
      } catch (error) {
        console.error('Error al guardar cambios:', error);// eslint-disable-line no-console
      }
    }
  },
  mounted() {
    this.cargarServicios();
  }
};
</script>
